(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlinx-serialization-kotlinx-serialization-core.js', './kotlin-kotlin-stdlib.js', './fixers-s2-s2-automate-s2-automate-dsl.js', './fixers-f2-f2-dsl-f2-dsl-cqrs.js', './boislocal-platform-platform-infra-commons-commons-domain.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlinx-serialization-kotlinx-serialization-core.js'), require('./kotlin-kotlin-stdlib.js'), require('./fixers-s2-s2-automate-s2-automate-dsl.js'), require('./fixers-f2-f2-dsl-f2-dsl-cqrs.js'), require('./boislocal-platform-platform-infra-commons-commons-domain.js'));
  else {
    if (typeof this['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'. Its dependency 'kotlinx-serialization-kotlinx-serialization-core' was not found. Please, check whether 'kotlinx-serialization-kotlinx-serialization-core' is loaded prior to 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'.");
    }
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'.");
    }
    if (typeof this['fixers-s2-s2-automate-s2-automate-dsl'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'. Its dependency 'fixers-s2-s2-automate-s2-automate-dsl' was not found. Please, check whether 'fixers-s2-s2-automate-s2-automate-dsl' is loaded prior to 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'.");
    }
    if (typeof this['fixers-f2-f2-dsl-f2-dsl-cqrs'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'. Its dependency 'fixers-f2-f2-dsl-f2-dsl-cqrs' was not found. Please, check whether 'fixers-f2-f2-dsl-f2-dsl-cqrs' is loaded prior to 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'.");
    }
    if (typeof this['boislocal-platform-platform-infra-commons-commons-domain'] === 'undefined') {
      throw new Error("Error loading module 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'. Its dependency 'boislocal-platform-platform-infra-commons-commons-domain' was not found. Please, check whether 'boislocal-platform-platform-infra-commons-commons-domain' is loaded prior to 'boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'.");
    }
    root['boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'] = factory(typeof this['boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'] === 'undefined' ? {} : this['boislocal-platform-platform-s2-referential-organizationType-organizationType-domain'], this['kotlinx-serialization-kotlinx-serialization-core'], this['kotlin-kotlin-stdlib'], this['fixers-s2-s2-automate-s2-automate-dsl'], this['fixers-f2-f2-dsl-f2-dsl-cqrs'], this['boislocal-platform-platform-infra-commons-commons-domain']);
  }
}(this, function (_, kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core, kotlin_kotlin, kotlin_io_komune_s2_s2_automate_dsl, kotlin_io_komune_f2_f2_dsl_cqrs, kotlin_org_boislocal_commons_domain) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var createSimpleEnumSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.c2;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.i;
  var lazy = kotlin_kotlin.$_$.ge;
  var protoOf = kotlin_kotlin.$_$.fa;
  var SerializerFactory = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.b2;
  var objectMeta = kotlin_kotlin.$_$.ea;
  var setMetadataFor = kotlin_kotlin.$_$.ga;
  var VOID = kotlin_kotlin.$_$.g;
  var THROW_IAE = kotlin_kotlin.$_$.ld;
  var Unit_instance = kotlin_kotlin.$_$.t4;
  var Enum = kotlin_kotlin.$_$.zc;
  var defineProp = kotlin_kotlin.$_$.b9;
  var S2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.j;
  var classMeta = kotlin_kotlin.$_$.z8;
  var S2TransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.b;
  var toValue = kotlin_io_komune_s2_s2_automate_dsl.$_$.m;
  var toValue_0 = kotlin_io_komune_s2_s2_automate_dsl.$_$.n;
  var getKClass = kotlin_kotlin.$_$.f;
  var toValue_1 = kotlin_io_komune_s2_s2_automate_dsl.$_$.l;
  var S2Transition = kotlin_io_komune_s2_s2_automate_dsl.$_$.k;
  var S2SelfTransitionBuilder = kotlin_io_komune_s2_s2_automate_dsl.$_$.a;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.j5;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var s2Sourcing = kotlin_io_komune_s2_s2_automate_dsl.$_$.c;
  var PluginGeneratedSerialDescriptor = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.z1;
  var StringSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.r;
  var UnknownFieldException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e;
  var THROW_CCE = kotlin_kotlin.$_$.kd;
  var typeParametersSerializers = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.u1;
  var GeneratedSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v1;
  var throwMissingFieldException = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.e2;
  var objectCreate = kotlin_kotlin.$_$.da;
  var S2Role = kotlin_io_komune_s2_s2_automate_dsl.$_$.i;
  var S2InitCommand = kotlin_io_komune_s2_s2_automate_dsl.$_$.h;
  var interfaceMeta = kotlin_kotlin.$_$.k9;
  var WithS2Id = kotlin_io_komune_s2_s2_automate_dsl.$_$.e;
  var Event = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.d;
  var ArrayListSerializer = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.s1;
  var get_nullable = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.v;
  var LongSerializer_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_serialization_core.$_$.q;
  var toString = kotlin_kotlin.$_$.le;
  var getStringHashCode = kotlin_kotlin.$_$.i9;
  var hashCode = kotlin_kotlin.$_$.j9;
  var equals = kotlin_kotlin.$_$.c9;
  var $serializer_getInstance = kotlin_org_boislocal_commons_domain.$_$.g;
  var S2Command = kotlin_io_komune_s2_s2_automate_dsl.$_$.g;
  var Long = kotlin_kotlin.$_$.ed;
  var $serializer_getInstance_0 = kotlin_org_boislocal_commons_domain.$_$.c;
  var WithS2State = kotlin_io_komune_s2_s2_automate_dsl.$_$.f;
  var Roles_instance = kotlin_org_boislocal_commons_domain.$_$.b;
  var hasRole = kotlin_org_boislocal_commons_domain.$_$.m;
  var ensureNotNull = kotlin_kotlin.$_$.be;
  var isAvailableTransition = kotlin_io_komune_s2_s2_automate_dsl.$_$.d;
  var Query = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.e;
  var PageQueryDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.a;
  var PageQueryResultDTO = kotlin_io_komune_f2_f2_dsl_cqrs.$_$.b;
  //endregion
  //region block: pre-declaration
  setMetadataFor(Companion, 'Companion', objectMeta, VOID, [SerializerFactory]);
  setMetadataFor(OrganizationTypeState, 'OrganizationTypeState', classMeta, Enum, [Enum, S2State], VOID, VOID, {0: Companion_getInstance});
  setMetadataFor(S2, 'S2', objectMeta);
  setMetadataFor(UserRole, 'UserRole', classMeta, VOID, [S2Role], VOID, VOID, {0: $serializer_getInstance_1});
  setMetadataFor(User, 'User', objectMeta, UserRole);
  setMetadataFor(Companion_0, 'Companion', objectMeta);
  setMetadataFor($serializer, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OrganizationTypeCreateCommandDTO, 'OrganizationTypeCreateCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(OrganizationTypeCreatedEventDTO, 'OrganizationTypeCreatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_1, 'Companion', objectMeta);
  setMetadataFor($serializer_0, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OrganizationTypeCreateCommand, 'OrganizationTypeCreateCommand', classMeta, VOID, [OrganizationTypeCreateCommandDTO], VOID, VOID, {0: $serializer_getInstance_2});
  setMetadataFor(Companion_2, 'Companion', objectMeta);
  setMetadataFor($serializer_1, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OrganizationTypeCreatedEvent, 'OrganizationTypeCreatedEvent', classMeta, VOID, [OrganizationTypeCreatedEventDTO], VOID, VOID, {0: $serializer_getInstance_3});
  setMetadataFor(OrganizationTypeDeleteCommandDTO, 'OrganizationTypeDeleteCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(OrganizationTypeDeletedEventDTO, 'OrganizationTypeDeletedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_3, 'Companion', objectMeta);
  setMetadataFor($serializer_2, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OrganizationTypeDeleteCommand, 'OrganizationTypeDeleteCommand', classMeta, VOID, [OrganizationTypeDeleteCommandDTO], VOID, VOID, {0: $serializer_getInstance_4});
  setMetadataFor(Companion_4, 'Companion', objectMeta);
  setMetadataFor($serializer_3, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OrganizationTypeDeletedEvent, 'OrganizationTypeDeletedEvent', classMeta, VOID, [OrganizationTypeDeletedEventDTO], VOID, VOID, {0: $serializer_getInstance_5});
  setMetadataFor(OrganizationTypeImportCommandDTO, 'OrganizationTypeImportCommandDTO', interfaceMeta, VOID, [S2InitCommand]);
  setMetadataFor(OrganizationTypeImportedEventDTO, 'OrganizationTypeImportedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_5, 'Companion', objectMeta);
  setMetadataFor($serializer_4, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OrganizationTypeImportCommand, 'OrganizationTypeImportCommand', classMeta, VOID, [OrganizationTypeImportCommandDTO], VOID, VOID, {0: $serializer_getInstance_6});
  setMetadataFor(Companion_6, 'Companion', objectMeta);
  setMetadataFor($serializer_5, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OrganizationTypeImportedEvent, 'OrganizationTypeImportedEvent', classMeta, VOID, [OrganizationTypeImportedEventDTO], VOID, VOID, {0: $serializer_getInstance_7});
  setMetadataFor(OrganizationTypeUpdateCommandDTO, 'OrganizationTypeUpdateCommandDTO', interfaceMeta, VOID, [S2Command]);
  setMetadataFor(OrganizationTypeUpdatedEventDTO, 'OrganizationTypeUpdatedEventDTO', interfaceMeta, VOID, [WithS2Id, Event]);
  setMetadataFor(Companion_7, 'Companion', objectMeta);
  setMetadataFor($serializer_6, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OrganizationTypeUpdateCommand, 'OrganizationTypeUpdateCommand', classMeta, VOID, [OrganizationTypeUpdateCommandDTO], VOID, VOID, {0: $serializer_getInstance_8});
  setMetadataFor(Companion_8, 'Companion', objectMeta);
  setMetadataFor($serializer_7, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OrganizationTypeUpdatedEvent, 'OrganizationTypeUpdatedEvent', classMeta, VOID, [OrganizationTypeUpdatedEventDTO], VOID, VOID, {0: $serializer_getInstance_9});
  setMetadataFor(OrganizationDTO, 'OrganizationDTO', interfaceMeta);
  setMetadataFor(Companion_9, 'Companion', objectMeta);
  setMetadataFor($serializer_8, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(Organization, 'Organization', classMeta, VOID, [OrganizationDTO], VOID, VOID, {0: $serializer_getInstance_10});
  setMetadataFor(OrganizationTypeModelDTO, 'OrganizationTypeModelDTO', interfaceMeta, VOID, [WithS2State, WithS2Id]);
  setMetadataFor(Companion_10, 'Companion', objectMeta);
  setMetadataFor($serializer_9, '$serializer', objectMeta, VOID, [GeneratedSerializer]);
  setMetadataFor(OrganizationTypeModel, 'OrganizationTypeModel', classMeta, VOID, [OrganizationTypeModelDTO], VOID, VOID, {0: $serializer_getInstance_11});
  setMetadataFor(OrganizationTypePolicies, 'OrganizationTypePolicies', objectMeta);
  setMetadataFor(OrganizationTypeGetQueryDTO, 'OrganizationTypeGetQueryDTO', interfaceMeta, VOID, [Query]);
  setMetadataFor(OrganizationTypeGetResponseDTO, 'OrganizationTypeGetResponseDTO', interfaceMeta);
  setMetadataFor(OrganizationTypePageQueryDTO, 'OrganizationTypePageQueryDTO', interfaceMeta, VOID, [PageQueryDTO]);
  setMetadataFor(OrganizationTypePageResponseDTO, 'OrganizationTypePageResponseDTO', interfaceMeta, VOID, [PageQueryResultDTO]);
  //endregion
  function _get_$cachedSerializer__te6jhj($this) {
    return $this.u2c_1.f2();
  }
  function OrganizationTypeState$Companion$_anonymous__aog5v9() {
    return createSimpleEnumSerializer('org.boislocal.platform.s2.organizationType.domain.automate.OrganizationTypeState', values());
  }
  var OrganizationTypeState_Exists_instance;
  var OrganizationTypeState_Deleted_instance;
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.u2c_1 = lazy(tmp_0, OrganizationTypeState$Companion$_anonymous__aog5v9);
  }
  protoOf(Companion).x14 = function () {
    return _get_$cachedSerializer__te6jhj(this);
  };
  protoOf(Companion).hu = function (typeParamsSerializers) {
    return this.x14();
  };
  var Companion_instance;
  function Companion_getInstance() {
    OrganizationTypeState_initEntries();
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function values() {
    return [OrganizationTypeState_Exists_getInstance(), OrganizationTypeState_Deleted_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'Exists':
        return OrganizationTypeState_Exists_getInstance();
      case 'Deleted':
        return OrganizationTypeState_Deleted_getInstance();
      default:
        OrganizationTypeState_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var OrganizationTypeState_entriesInitialized;
  function OrganizationTypeState_initEntries() {
    if (OrganizationTypeState_entriesInitialized)
      return Unit_instance;
    OrganizationTypeState_entriesInitialized = true;
    OrganizationTypeState_Exists_instance = new OrganizationTypeState('Exists', 0, 0);
    OrganizationTypeState_Deleted_instance = new OrganizationTypeState('Deleted', 1, 1);
    Companion_getInstance();
  }
  function OrganizationTypeState(name, ordinal, position) {
    Enum.call(this, name, ordinal);
    this.x2c_1 = position;
  }
  protoOf(OrganizationTypeState).y2c = function (_set____db54di) {
    this.x2c_1 = _set____db54di;
  };
  protoOf(OrganizationTypeState).jr = function () {
    return this.x2c_1;
  };
  function S2$organizationTypeAutomate$lambda($this$s2Sourcing) {
    $this$s2Sourcing.j27_1 = 'OrganizationType';
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.organizationType.domain.automate.S2.organizationTypeAutomate.<anonymous>.<anonymous>' call
    builder.o27_1 = OrganizationTypeState_Exists_getInstance();
    builder.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver = builder.m27_1;
    var tmp = tmp0_safe_receiver == null ? null : toValue(tmp0_safe_receiver);
    var tmp_0 = toValue(builder.c24());
    var tmp_1 = toValue_0(builder.d24());
    var tmp_2 = toValue_1(getKClass(OrganizationTypeImportCommand));
    var tmp1_elvis_lhs = builder.q27_1;
    var this_0 = new S2Transition(tmp, tmp_0, tmp_1, tmp_2, toValue_1(tmp1_elvis_lhs == null ? getKClass(OrganizationTypeImportedEvent) : tmp1_elvis_lhs));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_0);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_0 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.organizationType.domain.automate.S2.organizationTypeAutomate.<anonymous>.<anonymous>' call
    builder_0.o27_1 = OrganizationTypeState_Deleted_getInstance();
    builder_0.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_0 = builder_0.m27_1;
    var tmp_3 = tmp0_safe_receiver_0 == null ? null : toValue(tmp0_safe_receiver_0);
    var tmp_4 = toValue(builder_0.c24());
    var tmp_5 = toValue_0(builder_0.d24());
    var tmp_6 = toValue_1(getKClass(OrganizationTypeImportCommand));
    var tmp1_elvis_lhs_0 = builder_0.q27_1;
    var this_1 = new S2Transition(tmp_3, tmp_4, tmp_5, tmp_6, toValue_1(tmp1_elvis_lhs_0 == null ? getKClass(OrganizationTypeImportedEvent) : tmp1_elvis_lhs_0));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_1);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_1 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.organizationType.domain.automate.S2.organizationTypeAutomate.<anonymous>.<anonymous>' call
    builder_1.o27_1 = OrganizationTypeState_Exists_getInstance();
    builder_1.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_1 = builder_1.m27_1;
    var tmp_7 = tmp0_safe_receiver_1 == null ? null : toValue(tmp0_safe_receiver_1);
    var tmp_8 = toValue(builder_1.c24());
    var tmp_9 = toValue_0(builder_1.d24());
    var tmp_10 = toValue_1(getKClass(OrganizationTypeCreateCommand));
    var tmp1_elvis_lhs_1 = builder_1.q27_1;
    var this_2 = new S2Transition(tmp_7, tmp_8, tmp_9, tmp_10, toValue_1(tmp1_elvis_lhs_1 == null ? getKClass(OrganizationTypeCreatedEvent) : tmp1_elvis_lhs_1));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_2);
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction' call
    var builder_2 = new S2SelfTransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.organizationType.domain.automate.S2.organizationTypeAutomate.<anonymous>.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_3 = builder_2.r27_1;
    var element = OrganizationTypeState_Exists_getInstance();
    this_3.r(element);
    builder_2.s27_1 = User_getInstance();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.map' call
    var this_4 = builder_2.r27_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
    var tmp0_iterator = this_4.u();
    while (tmp0_iterator.v()) {
      var item = tmp0_iterator.w();
      // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.selfTransaction.<anonymous>' call
      var tmp_11 = toValue(item);
      var tmp_12 = toValue(item);
      var tmp_13 = toValue_0(builder_2.d24());
      var tmp_14 = toValue_1(getKClass(OrganizationTypeUpdateCommand));
      var tmp0_elvis_lhs = builder_2.t27_1;
      var tmp$ret$6 = new S2Transition(tmp_11, tmp_12, tmp_13, tmp_14, toValue_1(tmp0_elvis_lhs == null ? getKClass(OrganizationTypeUpdatedEvent) : tmp0_elvis_lhs));
      destination.r(tmp$ret$6);
    }
    var tmp3_forEach_receiver = $this$s2Sourcing.l27_1;
    var tmp0_iterator_0 = destination.u();
    while (tmp0_iterator_0.v()) {
      var element_0 = tmp0_iterator_0.w();
      invoke$add(tmp3_forEach_receiver, element_0);
    }
    // Inline function 's2.dsl.automate.builder.S2SourcingAutomateBuilder.transaction' call
    var builder_3 = new S2TransitionBuilder();
    // Inline function 'org.boislocal.platform.s2.organizationType.domain.automate.S2.organizationTypeAutomate.<anonymous>.<anonymous>' call
    builder_3.m27_1 = OrganizationTypeState_Exists_getInstance();
    builder_3.o27_1 = OrganizationTypeState_Deleted_getInstance();
    builder_3.p27_1 = User_getInstance();
    // Inline function 'kotlin.let' call
    var tmp0_safe_receiver_2 = builder_3.m27_1;
    var tmp_15 = tmp0_safe_receiver_2 == null ? null : toValue(tmp0_safe_receiver_2);
    var tmp_16 = toValue(builder_3.c24());
    var tmp_17 = toValue_0(builder_3.d24());
    var tmp_18 = toValue_1(getKClass(OrganizationTypeDeleteCommand));
    var tmp1_elvis_lhs_2 = builder_3.q27_1;
    var this_5 = new S2Transition(tmp_15, tmp_16, tmp_17, tmp_18, toValue_1(tmp1_elvis_lhs_2 == null ? getKClass(OrganizationTypeDeletedEvent) : tmp1_elvis_lhs_2));
    // Inline function 'kotlin.contracts.contract' call
    $this$s2Sourcing.l27_1.r(this_5);
    return Unit_instance;
  }
  function invoke$add(receiver, p0) {
    receiver.r(p0);
  }
  function S2() {
    S2_instance = this;
    var tmp = this;
    tmp.z2c_1 = s2Sourcing(S2$organizationTypeAutomate$lambda);
  }
  var S2_instance;
  function S2_getInstance() {
    if (S2_instance == null)
      new S2();
    return S2_instance;
  }
  function User() {
    User_instance = this;
    UserRole.call(this, 'User');
  }
  var User_instance;
  function User_getInstance() {
    if (User_instance == null)
      new User();
    return User_instance;
  }
  function Companion_0() {
  }
  var Companion_instance_0;
  function Companion_getInstance_0() {
    return Companion_instance_0;
  }
  function $serializer() {
    $serializer_instance = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.organizationType.domain.automate.UserRole', this, 1);
    tmp0_serialDesc.ht('name', false);
    this.b2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer).ii = function () {
    return this.b2d_1;
  };
  protoOf($serializer).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer).ki = function (decoder) {
    var tmp0_desc = this.b2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return UserRole_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer).c2d = function (encoder, value) {
    var tmp0_desc = this.b2d_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.h9());
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer).ji = function (encoder, value) {
    return this.c2d(encoder, value instanceof UserRole ? value : THROW_CCE());
  };
  var $serializer_instance;
  function $serializer_getInstance_1() {
    if ($serializer_instance == null)
      new $serializer();
    return $serializer_instance;
  }
  function UserRole_init_$Init$(seen1, name, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_1().b2d_1);
    }
    $this.a2d_1 = name;
    return $this;
  }
  function UserRole_init_$Create$(seen1, name, serializationConstructorMarker) {
    return UserRole_init_$Init$(seen1, name, serializationConstructorMarker, objectCreate(protoOf(UserRole)));
  }
  function UserRole(name) {
    this.a2d_1 = name;
  }
  protoOf(UserRole).h9 = function () {
    return this.a2d_1;
  };
  protoOf(UserRole).toString = function () {
    return this.h9();
  };
  function OrganizationTypeState_Exists_getInstance() {
    OrganizationTypeState_initEntries();
    return OrganizationTypeState_Exists_instance;
  }
  function OrganizationTypeState_Deleted_getInstance() {
    OrganizationTypeState_initEntries();
    return OrganizationTypeState_Deleted_instance;
  }
  function OrganizationTypeCreateCommandDTO() {
  }
  function OrganizationTypeCreatedEventDTO() {
  }
  function Companion_1() {
    Companion_instance_1 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.g2d_1 = [null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null];
  }
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function $serializer_0() {
    $serializer_instance_0 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.organizationType.domain.command.OrganizationTypeCreateCommand', this, 6);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('description', false);
    tmp0_serialDesc.ht('permissions', false);
    tmp0_serialDesc.ht('total', false);
    tmp0_serialDesc.ht('referencesLink', false);
    this.h2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_0).ii = function () {
    return this.h2d_1;
  };
  protoOf($serializer_0).wt = function () {
    var tmp0_cached = Companion_getInstance_1().g2d_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3]), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_0).ki = function (decoder) {
    var tmp0_desc = this.h2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.ul(tmp0_desc);
    var tmp11_cached = Companion_getInstance_1().g2d_1;
    if (tmp10_input.km()) {
      tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.im(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.im(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.vl(tmp0_desc);
    return OrganizationTypeCreateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_0).i2d = function (encoder, value) {
    var tmp0_desc = this.h2d_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_1().g2d_1;
    tmp1_output.jn(tmp0_desc, 0, value.j2d_1);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.k2d_1);
    tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.l2d_1);
    tmp1_output.nn(tmp0_desc, 3, tmp2_cached[3], value.m2d_1);
    tmp1_output.nn(tmp0_desc, 4, LongSerializer_getInstance(), value.n2d_1);
    tmp1_output.nn(tmp0_desc, 5, StringSerializer_getInstance(), value.o2d_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_0).ji = function (encoder, value) {
    return this.i2d(encoder, value instanceof OrganizationTypeCreateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_0;
  function $serializer_getInstance_2() {
    if ($serializer_instance_0 == null)
      new $serializer_0();
    return $serializer_instance_0;
  }
  function OrganizationTypeCreateCommand_init_$Init$(seen1, name, img, description, permissions, total, referencesLink, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen1))) {
      throwMissingFieldException(seen1, 63, $serializer_getInstance_2().h2d_1);
    }
    $this.j2d_1 = name;
    $this.k2d_1 = img;
    $this.l2d_1 = description;
    $this.m2d_1 = permissions;
    $this.n2d_1 = total;
    $this.o2d_1 = referencesLink;
    return $this;
  }
  function OrganizationTypeCreateCommand_init_$Create$(seen1, name, img, description, permissions, total, referencesLink, serializationConstructorMarker) {
    return OrganizationTypeCreateCommand_init_$Init$(seen1, name, img, description, permissions, total, referencesLink, serializationConstructorMarker, objectCreate(protoOf(OrganizationTypeCreateCommand)));
  }
  function OrganizationTypeCreateCommand(name, img, description, permissions, total, referencesLink) {
    Companion_getInstance_1();
    this.j2d_1 = name;
    this.k2d_1 = img;
    this.l2d_1 = description;
    this.m2d_1 = permissions;
    this.n2d_1 = total;
    this.o2d_1 = referencesLink;
  }
  protoOf(OrganizationTypeCreateCommand).h9 = function () {
    return this.j2d_1;
  };
  protoOf(OrganizationTypeCreateCommand).d2d = function () {
    return this.k2d_1;
  };
  protoOf(OrganizationTypeCreateCommand).w25 = function () {
    return this.l2d_1;
  };
  protoOf(OrganizationTypeCreateCommand).e2d = function () {
    return this.m2d_1;
  };
  protoOf(OrganizationTypeCreateCommand).i1z = function () {
    return this.n2d_1;
  };
  protoOf(OrganizationTypeCreateCommand).f2d = function () {
    return this.o2d_1;
  };
  protoOf(OrganizationTypeCreateCommand).toString = function () {
    return 'OrganizationTypeCreateCommand(name=' + this.j2d_1 + ', img=' + this.k2d_1 + ', description=' + this.l2d_1 + ', permissions=' + this.m2d_1 + ', total=' + toString(this.n2d_1) + ', referencesLink=' + this.o2d_1 + ')';
  };
  protoOf(OrganizationTypeCreateCommand).hashCode = function () {
    var result = getStringHashCode(this.j2d_1);
    result = imul(result, 31) + (this.k2d_1 == null ? 0 : getStringHashCode(this.k2d_1)) | 0;
    result = imul(result, 31) + (this.l2d_1 == null ? 0 : getStringHashCode(this.l2d_1)) | 0;
    result = imul(result, 31) + (this.m2d_1 == null ? 0 : hashCode(this.m2d_1)) | 0;
    result = imul(result, 31) + (this.n2d_1 == null ? 0 : this.n2d_1.hashCode()) | 0;
    result = imul(result, 31) + (this.o2d_1 == null ? 0 : getStringHashCode(this.o2d_1)) | 0;
    return result;
  };
  protoOf(OrganizationTypeCreateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrganizationTypeCreateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof OrganizationTypeCreateCommand ? other : THROW_CCE();
    if (!(this.j2d_1 === tmp0_other_with_cast.j2d_1))
      return false;
    if (!(this.k2d_1 == tmp0_other_with_cast.k2d_1))
      return false;
    if (!(this.l2d_1 == tmp0_other_with_cast.l2d_1))
      return false;
    if (!equals(this.m2d_1, tmp0_other_with_cast.m2d_1))
      return false;
    if (!equals(this.n2d_1, tmp0_other_with_cast.n2d_1))
      return false;
    if (!(this.o2d_1 == tmp0_other_with_cast.o2d_1))
      return false;
    return true;
  };
  function Companion_2() {
    Companion_instance_2 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.p2d_1 = [null, null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null];
  }
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function $serializer_1() {
    $serializer_instance_1 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OrganizationTypeCreatedEvent', this, 8);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('description', false);
    tmp0_serialDesc.ht('permissions', false);
    tmp0_serialDesc.ht('total', false);
    tmp0_serialDesc.ht('referencesLink', false);
    tmp0_serialDesc.ht('time', false);
    this.q2d_1 = tmp0_serialDesc;
  }
  protoOf($serializer_1).ii = function () {
    return this.q2d_1;
  };
  protoOf($serializer_1).wt = function () {
    var tmp0_cached = Companion_getInstance_2().p2d_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[4]), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_1).ki = function (decoder) {
    var tmp0_desc = this.q2d_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_input = decoder.ul(tmp0_desc);
    var tmp13_cached = Companion_getInstance_2().p2d_1;
    if (tmp12_input.km()) {
      tmp4_local0 = tmp12_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp12_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp12_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp12_input.im(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp12_input.im(tmp0_desc, 4, tmp13_cached[4], tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp12_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp12_input.im(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp12_input.im(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp12_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp12_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp12_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp12_input.im(tmp0_desc, 2, $serializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp12_input.im(tmp0_desc, 3, StringSerializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp12_input.im(tmp0_desc, 4, tmp13_cached[4], tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp12_input.im(tmp0_desc, 5, LongSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp12_input.im(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp12_input.im(tmp0_desc, 7, LongSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp12_input.vl(tmp0_desc);
    return OrganizationTypeCreatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, null);
  };
  protoOf($serializer_1).r2d = function (encoder, value) {
    var tmp0_desc = this.q2d_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_2().p2d_1;
    tmp1_output.jn(tmp0_desc, 0, value.s2d_1);
    tmp1_output.jn(tmp0_desc, 1, value.t2d_1);
    tmp1_output.nn(tmp0_desc, 2, $serializer_getInstance(), value.u2d_1);
    tmp1_output.nn(tmp0_desc, 3, StringSerializer_getInstance(), value.v2d_1);
    tmp1_output.nn(tmp0_desc, 4, tmp2_cached[4], value.w2d_1);
    tmp1_output.nn(tmp0_desc, 5, LongSerializer_getInstance(), value.x2d_1);
    tmp1_output.nn(tmp0_desc, 6, StringSerializer_getInstance(), value.y2d_1);
    tmp1_output.nn(tmp0_desc, 7, LongSerializer_getInstance(), value.z2d_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_1).ji = function (encoder, value) {
    return this.r2d(encoder, value instanceof OrganizationTypeCreatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_1;
  function $serializer_getInstance_3() {
    if ($serializer_instance_1 == null)
      new $serializer_1();
    return $serializer_instance_1;
  }
  function OrganizationTypeCreatedEvent_init_$Init$(seen1, id, name, img, description, permissions, total, referencesLink, time, serializationConstructorMarker, $this) {
    if (!(255 === (255 & seen1))) {
      throwMissingFieldException(seen1, 255, $serializer_getInstance_3().q2d_1);
    }
    $this.s2d_1 = id;
    $this.t2d_1 = name;
    $this.u2d_1 = img;
    $this.v2d_1 = description;
    $this.w2d_1 = permissions;
    $this.x2d_1 = total;
    $this.y2d_1 = referencesLink;
    $this.z2d_1 = time;
    return $this;
  }
  function OrganizationTypeCreatedEvent_init_$Create$(seen1, id, name, img, description, permissions, total, referencesLink, time, serializationConstructorMarker) {
    return OrganizationTypeCreatedEvent_init_$Init$(seen1, id, name, img, description, permissions, total, referencesLink, time, serializationConstructorMarker, objectCreate(protoOf(OrganizationTypeCreatedEvent)));
  }
  function OrganizationTypeCreatedEvent(id, name, img, description, permissions, total, referencesLink, time) {
    Companion_getInstance_2();
    this.s2d_1 = id;
    this.t2d_1 = name;
    this.u2d_1 = img;
    this.v2d_1 = description;
    this.w2d_1 = permissions;
    this.x2d_1 = total;
    this.y2d_1 = referencesLink;
    this.z2d_1 = time;
  }
  protoOf(OrganizationTypeCreatedEvent).k1y = function () {
    return this.s2d_1;
  };
  protoOf(OrganizationTypeCreatedEvent).h9 = function () {
    return this.t2d_1;
  };
  protoOf(OrganizationTypeCreatedEvent).d2d = function () {
    return this.u2d_1;
  };
  protoOf(OrganizationTypeCreatedEvent).w25 = function () {
    return this.v2d_1;
  };
  protoOf(OrganizationTypeCreatedEvent).e2d = function () {
    return this.w2d_1;
  };
  protoOf(OrganizationTypeCreatedEvent).i1z = function () {
    return this.x2d_1;
  };
  protoOf(OrganizationTypeCreatedEvent).f2d = function () {
    return this.y2d_1;
  };
  protoOf(OrganizationTypeCreatedEvent).g2c = function () {
    return this.z2d_1;
  };
  protoOf(OrganizationTypeCreatedEvent).s2Id = function () {
    return this.s2d_1;
  };
  protoOf(OrganizationTypeCreatedEvent).toString = function () {
    return 'OrganizationTypeCreatedEvent(id=' + this.s2d_1 + ', name=' + this.t2d_1 + ', img=' + this.u2d_1 + ', description=' + this.v2d_1 + ', permissions=' + this.w2d_1 + ', total=' + toString(this.x2d_1) + ', referencesLink=' + this.y2d_1 + ', time=' + toString(this.z2d_1) + ')';
  };
  protoOf(OrganizationTypeCreatedEvent).hashCode = function () {
    var result = getStringHashCode(this.s2d_1);
    result = imul(result, 31) + getStringHashCode(this.t2d_1) | 0;
    result = imul(result, 31) + (this.u2d_1 == null ? 0 : this.u2d_1.hashCode()) | 0;
    result = imul(result, 31) + (this.v2d_1 == null ? 0 : getStringHashCode(this.v2d_1)) | 0;
    result = imul(result, 31) + (this.w2d_1 == null ? 0 : hashCode(this.w2d_1)) | 0;
    result = imul(result, 31) + (this.x2d_1 == null ? 0 : this.x2d_1.hashCode()) | 0;
    result = imul(result, 31) + (this.y2d_1 == null ? 0 : getStringHashCode(this.y2d_1)) | 0;
    result = imul(result, 31) + (this.z2d_1 == null ? 0 : this.z2d_1.hashCode()) | 0;
    return result;
  };
  protoOf(OrganizationTypeCreatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrganizationTypeCreatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof OrganizationTypeCreatedEvent ? other : THROW_CCE();
    if (!(this.s2d_1 === tmp0_other_with_cast.s2d_1))
      return false;
    if (!(this.t2d_1 === tmp0_other_with_cast.t2d_1))
      return false;
    if (!equals(this.u2d_1, tmp0_other_with_cast.u2d_1))
      return false;
    if (!(this.v2d_1 == tmp0_other_with_cast.v2d_1))
      return false;
    if (!equals(this.w2d_1, tmp0_other_with_cast.w2d_1))
      return false;
    if (!equals(this.x2d_1, tmp0_other_with_cast.x2d_1))
      return false;
    if (!(this.y2d_1 == tmp0_other_with_cast.y2d_1))
      return false;
    if (!equals(this.z2d_1, tmp0_other_with_cast.z2d_1))
      return false;
    return true;
  };
  function OrganizationTypeDeleteCommandDTO() {
  }
  function OrganizationTypeDeletedEventDTO() {
  }
  function Companion_3() {
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    return Companion_instance_3;
  }
  function $serializer_2() {
    $serializer_instance_2 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.organizationType.domain.command.OrganizationTypeDeleteCommand', this, 1);
    tmp0_serialDesc.ht('id', false);
    this.a2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_2).ii = function () {
    return this.a2e_1;
  };
  protoOf($serializer_2).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance()];
  };
  protoOf($serializer_2).ki = function (decoder) {
    var tmp0_desc = this.a2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return OrganizationTypeDeleteCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_2).b2e = function (encoder, value) {
    var tmp0_desc = this.a2e_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.c2e_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_2).ji = function (encoder, value) {
    return this.b2e(encoder, value instanceof OrganizationTypeDeleteCommand ? value : THROW_CCE());
  };
  var $serializer_instance_2;
  function $serializer_getInstance_4() {
    if ($serializer_instance_2 == null)
      new $serializer_2();
    return $serializer_instance_2;
  }
  function OrganizationTypeDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_4().a2e_1);
    }
    $this.c2e_1 = id;
    return $this;
  }
  function OrganizationTypeDeleteCommand_init_$Create$(seen1, id, serializationConstructorMarker) {
    return OrganizationTypeDeleteCommand_init_$Init$(seen1, id, serializationConstructorMarker, objectCreate(protoOf(OrganizationTypeDeleteCommand)));
  }
  function OrganizationTypeDeleteCommand(id) {
    this.c2e_1 = id;
  }
  protoOf(OrganizationTypeDeleteCommand).k1y = function () {
    return this.c2e_1;
  };
  protoOf(OrganizationTypeDeleteCommand).toString = function () {
    return 'OrganizationTypeDeleteCommand(id=' + this.c2e_1 + ')';
  };
  protoOf(OrganizationTypeDeleteCommand).hashCode = function () {
    return getStringHashCode(this.c2e_1);
  };
  protoOf(OrganizationTypeDeleteCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrganizationTypeDeleteCommand))
      return false;
    var tmp0_other_with_cast = other instanceof OrganizationTypeDeleteCommand ? other : THROW_CCE();
    if (!(this.c2e_1 === tmp0_other_with_cast.c2e_1))
      return false;
    return true;
  };
  function Companion_4() {
  }
  var Companion_instance_4;
  function Companion_getInstance_4() {
    return Companion_instance_4;
  }
  function $serializer_3() {
    $serializer_instance_3 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OrganizationTypeDeletedEvent', this, 2);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('time', false);
    this.d2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_3).ii = function () {
    return this.d2e_1;
  };
  protoOf($serializer_3).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_3).ki = function (decoder) {
    var tmp0_desc = this.d2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.im(tmp0_desc, 1, LongSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return OrganizationTypeDeletedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_3).e2e = function (encoder, value) {
    var tmp0_desc = this.d2e_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.jn(tmp0_desc, 0, value.f2e_1);
    tmp1_output.nn(tmp0_desc, 1, LongSerializer_getInstance(), value.g2e_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_3).ji = function (encoder, value) {
    return this.e2e(encoder, value instanceof OrganizationTypeDeletedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_3;
  function $serializer_getInstance_5() {
    if ($serializer_instance_3 == null)
      new $serializer_3();
    return $serializer_instance_3;
  }
  function OrganizationTypeDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_5().d2e_1);
    }
    $this.f2e_1 = id;
    $this.g2e_1 = time;
    return $this;
  }
  function OrganizationTypeDeletedEvent_init_$Create$(seen1, id, time, serializationConstructorMarker) {
    return OrganizationTypeDeletedEvent_init_$Init$(seen1, id, time, serializationConstructorMarker, objectCreate(protoOf(OrganizationTypeDeletedEvent)));
  }
  function OrganizationTypeDeletedEvent(id, time) {
    this.f2e_1 = id;
    this.g2e_1 = time;
  }
  protoOf(OrganizationTypeDeletedEvent).k1y = function () {
    return this.f2e_1;
  };
  protoOf(OrganizationTypeDeletedEvent).g2c = function () {
    return this.g2e_1;
  };
  protoOf(OrganizationTypeDeletedEvent).s2Id = function () {
    return this.f2e_1;
  };
  protoOf(OrganizationTypeDeletedEvent).toString = function () {
    return 'OrganizationTypeDeletedEvent(id=' + this.f2e_1 + ', time=' + toString(this.g2e_1) + ')';
  };
  protoOf(OrganizationTypeDeletedEvent).hashCode = function () {
    var result = getStringHashCode(this.f2e_1);
    result = imul(result, 31) + (this.g2e_1 == null ? 0 : this.g2e_1.hashCode()) | 0;
    return result;
  };
  protoOf(OrganizationTypeDeletedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrganizationTypeDeletedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof OrganizationTypeDeletedEvent ? other : THROW_CCE();
    if (!(this.f2e_1 === tmp0_other_with_cast.f2e_1))
      return false;
    if (!equals(this.g2e_1, tmp0_other_with_cast.g2e_1))
      return false;
    return true;
  };
  function OrganizationTypeImportCommandDTO() {
  }
  function OrganizationTypeImportedEventDTO() {
  }
  function Companion_5() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function $serializer_4() {
    $serializer_instance_4 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.organizationType.domain.command.OrganizationTypeImportCommand', this, 1);
    tmp0_serialDesc.ht('item', false);
    this.h2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_4).ii = function () {
    return this.h2e_1;
  };
  protoOf($serializer_4).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_11()];
  };
  protoOf($serializer_4).ki = function (decoder) {
    var tmp0_desc = this.h2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_input = decoder.ul(tmp0_desc);
    if (tmp5_input.km()) {
      tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp5_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp5_input.gm(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp5_input.vl(tmp0_desc);
    return OrganizationTypeImportCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, null);
  };
  protoOf($serializer_4).i2e = function (encoder, value) {
    var tmp0_desc = this.h2e_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_11(), value.j2e_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_4).ji = function (encoder, value) {
    return this.i2e(encoder, value instanceof OrganizationTypeImportCommand ? value : THROW_CCE());
  };
  var $serializer_instance_4;
  function $serializer_getInstance_6() {
    if ($serializer_instance_4 == null)
      new $serializer_4();
    return $serializer_instance_4;
  }
  function OrganizationTypeImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, $this) {
    if (!(1 === (1 & seen1))) {
      throwMissingFieldException(seen1, 1, $serializer_getInstance_6().h2e_1);
    }
    $this.j2e_1 = item;
    return $this;
  }
  function OrganizationTypeImportCommand_init_$Create$(seen1, item, serializationConstructorMarker) {
    return OrganizationTypeImportCommand_init_$Init$(seen1, item, serializationConstructorMarker, objectCreate(protoOf(OrganizationTypeImportCommand)));
  }
  function OrganizationTypeImportCommand(item) {
    this.j2e_1 = item;
  }
  protoOf(OrganizationTypeImportCommand).q20 = function () {
    return this.j2e_1;
  };
  protoOf(OrganizationTypeImportCommand).toString = function () {
    return 'OrganizationTypeImportCommand(item=' + this.j2e_1 + ')';
  };
  protoOf(OrganizationTypeImportCommand).hashCode = function () {
    return this.j2e_1.hashCode();
  };
  protoOf(OrganizationTypeImportCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrganizationTypeImportCommand))
      return false;
    var tmp0_other_with_cast = other instanceof OrganizationTypeImportCommand ? other : THROW_CCE();
    if (!this.j2e_1.equals(tmp0_other_with_cast.j2e_1))
      return false;
    return true;
  };
  function Companion_6() {
  }
  var Companion_instance_6;
  function Companion_getInstance_6() {
    return Companion_instance_6;
  }
  function $serializer_5() {
    $serializer_instance_5 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OrganizationTypeImportedEvent', this, 2);
    tmp0_serialDesc.ht('item', false);
    tmp0_serialDesc.ht('time', false);
    this.k2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_5).ii = function () {
    return this.k2e_1;
  };
  protoOf($serializer_5).wt = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [$serializer_getInstance_11(), LongSerializer_getInstance()];
  };
  protoOf($serializer_5).ki = function (decoder) {
    var tmp0_desc = this.k2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = new Long(0, 0);
    var tmp6_input = decoder.ul(tmp0_desc);
    if (tmp6_input.km()) {
      tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp6_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp6_input.gm(tmp0_desc, 0, $serializer_getInstance_11(), tmp4_local0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp6_input.am(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp6_input.vl(tmp0_desc);
    return OrganizationTypeImportedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
  };
  protoOf($serializer_5).l2e = function (encoder, value) {
    var tmp0_desc = this.k2e_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    tmp1_output.ln(tmp0_desc, 0, $serializer_getInstance_11(), value.m2e_1);
    tmp1_output.fn(tmp0_desc, 1, value.n2e_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_5).ji = function (encoder, value) {
    return this.l2e(encoder, value instanceof OrganizationTypeImportedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_5;
  function $serializer_getInstance_7() {
    if ($serializer_instance_5 == null)
      new $serializer_5();
    return $serializer_instance_5;
  }
  function OrganizationTypeImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, $this) {
    if (!(3 === (3 & seen1))) {
      throwMissingFieldException(seen1, 3, $serializer_getInstance_7().k2e_1);
    }
    $this.m2e_1 = item;
    $this.n2e_1 = time;
    return $this;
  }
  function OrganizationTypeImportedEvent_init_$Create$(seen1, item, time, serializationConstructorMarker) {
    return OrganizationTypeImportedEvent_init_$Init$(seen1, item, time, serializationConstructorMarker, objectCreate(protoOf(OrganizationTypeImportedEvent)));
  }
  function OrganizationTypeImportedEvent(item, time) {
    this.m2e_1 = item;
    this.n2e_1 = time;
  }
  protoOf(OrganizationTypeImportedEvent).q20 = function () {
    return this.m2e_1;
  };
  protoOf(OrganizationTypeImportedEvent).g2c = function () {
    return this.n2e_1;
  };
  protoOf(OrganizationTypeImportedEvent).s2Id = function () {
    return this.m2e_1.o2e_1;
  };
  protoOf(OrganizationTypeImportedEvent).toString = function () {
    return 'OrganizationTypeImportedEvent(item=' + this.m2e_1 + ', time=' + this.n2e_1.toString() + ')';
  };
  protoOf(OrganizationTypeImportedEvent).hashCode = function () {
    var result = this.m2e_1.hashCode();
    result = imul(result, 31) + this.n2e_1.hashCode() | 0;
    return result;
  };
  protoOf(OrganizationTypeImportedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrganizationTypeImportedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof OrganizationTypeImportedEvent ? other : THROW_CCE();
    if (!this.m2e_1.equals(tmp0_other_with_cast.m2e_1))
      return false;
    if (!this.n2e_1.equals(tmp0_other_with_cast.n2e_1))
      return false;
    return true;
  };
  function OrganizationTypeUpdateCommandDTO() {
  }
  function OrganizationTypeUpdatedEventDTO() {
  }
  function Companion_7() {
    Companion_instance_7 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.y2e_1 = [null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null];
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_7();
    return Companion_instance_7;
  }
  function $serializer_6() {
    $serializer_instance_6 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.organizationType.domain.command.OrganizationTypeUpdateCommand', this, 6);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('description', false);
    tmp0_serialDesc.ht('permissions', false);
    tmp0_serialDesc.ht('total', false);
    tmp0_serialDesc.ht('referencesLink', false);
    this.z2e_1 = tmp0_serialDesc;
  }
  protoOf($serializer_6).ii = function () {
    return this.z2e_1;
  };
  protoOf($serializer_6).wt = function () {
    var tmp0_cached = Companion_getInstance_7().y2e_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3]), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
  };
  protoOf($serializer_6).ki = function (decoder) {
    var tmp0_desc = this.z2e_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_input = decoder.ul(tmp0_desc);
    var tmp11_cached = Companion_getInstance_7().y2e_1;
    if (tmp10_input.km()) {
      tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp10_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp10_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp10_input.im(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp10_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp10_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp10_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp10_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp10_input.im(tmp0_desc, 1, StringSerializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp10_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp10_input.im(tmp0_desc, 3, tmp11_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp10_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp10_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp10_input.vl(tmp0_desc);
    return OrganizationTypeUpdateCommand_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
  };
  protoOf($serializer_6).a2f = function (encoder, value) {
    var tmp0_desc = this.z2e_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_7().y2e_1;
    tmp1_output.jn(tmp0_desc, 0, value.b2f_1);
    tmp1_output.nn(tmp0_desc, 1, StringSerializer_getInstance(), value.c2f_1);
    tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.d2f_1);
    tmp1_output.nn(tmp0_desc, 3, tmp2_cached[3], value.e2f_1);
    tmp1_output.nn(tmp0_desc, 4, LongSerializer_getInstance(), value.f2f_1);
    tmp1_output.nn(tmp0_desc, 5, StringSerializer_getInstance(), value.g2f_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_6).ji = function (encoder, value) {
    return this.a2f(encoder, value instanceof OrganizationTypeUpdateCommand ? value : THROW_CCE());
  };
  var $serializer_instance_6;
  function $serializer_getInstance_8() {
    if ($serializer_instance_6 == null)
      new $serializer_6();
    return $serializer_instance_6;
  }
  function OrganizationTypeUpdateCommand_init_$Init$(seen1, id, img, description, permissions, total, referencesLink, serializationConstructorMarker, $this) {
    if (!(63 === (63 & seen1))) {
      throwMissingFieldException(seen1, 63, $serializer_getInstance_8().z2e_1);
    }
    $this.b2f_1 = id;
    $this.c2f_1 = img;
    $this.d2f_1 = description;
    $this.e2f_1 = permissions;
    $this.f2f_1 = total;
    $this.g2f_1 = referencesLink;
    return $this;
  }
  function OrganizationTypeUpdateCommand_init_$Create$(seen1, id, img, description, permissions, total, referencesLink, serializationConstructorMarker) {
    return OrganizationTypeUpdateCommand_init_$Init$(seen1, id, img, description, permissions, total, referencesLink, serializationConstructorMarker, objectCreate(protoOf(OrganizationTypeUpdateCommand)));
  }
  function OrganizationTypeUpdateCommand(id, img, description, permissions, total, referencesLink) {
    Companion_getInstance_7();
    this.b2f_1 = id;
    this.c2f_1 = img;
    this.d2f_1 = description;
    this.e2f_1 = permissions;
    this.f2f_1 = total;
    this.g2f_1 = referencesLink;
  }
  protoOf(OrganizationTypeUpdateCommand).k1y = function () {
    return this.b2f_1;
  };
  protoOf(OrganizationTypeUpdateCommand).d2d = function () {
    return this.c2f_1;
  };
  protoOf(OrganizationTypeUpdateCommand).w25 = function () {
    return this.d2f_1;
  };
  protoOf(OrganizationTypeUpdateCommand).e2d = function () {
    return this.e2f_1;
  };
  protoOf(OrganizationTypeUpdateCommand).i1z = function () {
    return this.f2f_1;
  };
  protoOf(OrganizationTypeUpdateCommand).f2d = function () {
    return this.g2f_1;
  };
  protoOf(OrganizationTypeUpdateCommand).toString = function () {
    return 'OrganizationTypeUpdateCommand(id=' + this.b2f_1 + ', img=' + this.c2f_1 + ', description=' + this.d2f_1 + ', permissions=' + this.e2f_1 + ', total=' + toString(this.f2f_1) + ', referencesLink=' + this.g2f_1 + ')';
  };
  protoOf(OrganizationTypeUpdateCommand).hashCode = function () {
    var result = getStringHashCode(this.b2f_1);
    result = imul(result, 31) + (this.c2f_1 == null ? 0 : getStringHashCode(this.c2f_1)) | 0;
    result = imul(result, 31) + (this.d2f_1 == null ? 0 : getStringHashCode(this.d2f_1)) | 0;
    result = imul(result, 31) + (this.e2f_1 == null ? 0 : hashCode(this.e2f_1)) | 0;
    result = imul(result, 31) + (this.f2f_1 == null ? 0 : this.f2f_1.hashCode()) | 0;
    result = imul(result, 31) + (this.g2f_1 == null ? 0 : getStringHashCode(this.g2f_1)) | 0;
    return result;
  };
  protoOf(OrganizationTypeUpdateCommand).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrganizationTypeUpdateCommand))
      return false;
    var tmp0_other_with_cast = other instanceof OrganizationTypeUpdateCommand ? other : THROW_CCE();
    if (!(this.b2f_1 === tmp0_other_with_cast.b2f_1))
      return false;
    if (!(this.c2f_1 == tmp0_other_with_cast.c2f_1))
      return false;
    if (!(this.d2f_1 == tmp0_other_with_cast.d2f_1))
      return false;
    if (!equals(this.e2f_1, tmp0_other_with_cast.e2f_1))
      return false;
    if (!equals(this.f2f_1, tmp0_other_with_cast.f2f_1))
      return false;
    if (!(this.g2f_1 == tmp0_other_with_cast.g2f_1))
      return false;
    return true;
  };
  function Companion_8() {
    Companion_instance_8 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.h2f_1 = [null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null];
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    if (Companion_instance_8 == null)
      new Companion_8();
    return Companion_instance_8;
  }
  function $serializer_7() {
    $serializer_instance_7 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('OrganizationTypeUpdatedEvent', this, 7);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('img', false);
    tmp0_serialDesc.ht('description', false);
    tmp0_serialDesc.ht('permissions', false);
    tmp0_serialDesc.ht('total', false);
    tmp0_serialDesc.ht('referencesLink', false);
    tmp0_serialDesc.ht('time', false);
    this.i2f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_7).ii = function () {
    return this.i2f_1;
  };
  protoOf($serializer_7).wt = function () {
    var tmp0_cached = Companion_getInstance_8().h2f_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[3]), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_7).ki = function (decoder) {
    var tmp0_desc = this.i2f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_input = decoder.ul(tmp0_desc);
    var tmp12_cached = Companion_getInstance_8().h2f_1;
    if (tmp11_input.km()) {
      tmp4_local0 = tmp11_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp11_input.im(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp11_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp11_input.im(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp11_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp11_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp11_input.im(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp11_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp11_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp11_input.im(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp11_input.im(tmp0_desc, 2, StringSerializer_getInstance(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp11_input.im(tmp0_desc, 3, tmp12_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp11_input.im(tmp0_desc, 4, LongSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp11_input.im(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp11_input.im(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp11_input.vl(tmp0_desc);
    return OrganizationTypeUpdatedEvent_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
  };
  protoOf($serializer_7).j2f = function (encoder, value) {
    var tmp0_desc = this.i2f_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_8().h2f_1;
    tmp1_output.jn(tmp0_desc, 0, value.k2f_1);
    tmp1_output.nn(tmp0_desc, 1, $serializer_getInstance(), value.l2f_1);
    tmp1_output.nn(tmp0_desc, 2, StringSerializer_getInstance(), value.m2f_1);
    tmp1_output.nn(tmp0_desc, 3, tmp2_cached[3], value.n2f_1);
    tmp1_output.nn(tmp0_desc, 4, LongSerializer_getInstance(), value.o2f_1);
    tmp1_output.nn(tmp0_desc, 5, StringSerializer_getInstance(), value.p2f_1);
    tmp1_output.nn(tmp0_desc, 6, LongSerializer_getInstance(), value.q2f_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_7).ji = function (encoder, value) {
    return this.j2f(encoder, value instanceof OrganizationTypeUpdatedEvent ? value : THROW_CCE());
  };
  var $serializer_instance_7;
  function $serializer_getInstance_9() {
    if ($serializer_instance_7 == null)
      new $serializer_7();
    return $serializer_instance_7;
  }
  function OrganizationTypeUpdatedEvent_init_$Init$(seen1, id, img, description, permissions, total, referencesLink, time, serializationConstructorMarker, $this) {
    if (!(127 === (127 & seen1))) {
      throwMissingFieldException(seen1, 127, $serializer_getInstance_9().i2f_1);
    }
    $this.k2f_1 = id;
    $this.l2f_1 = img;
    $this.m2f_1 = description;
    $this.n2f_1 = permissions;
    $this.o2f_1 = total;
    $this.p2f_1 = referencesLink;
    $this.q2f_1 = time;
    return $this;
  }
  function OrganizationTypeUpdatedEvent_init_$Create$(seen1, id, img, description, permissions, total, referencesLink, time, serializationConstructorMarker) {
    return OrganizationTypeUpdatedEvent_init_$Init$(seen1, id, img, description, permissions, total, referencesLink, time, serializationConstructorMarker, objectCreate(protoOf(OrganizationTypeUpdatedEvent)));
  }
  function OrganizationTypeUpdatedEvent(id, img, description, permissions, total, referencesLink, time) {
    Companion_getInstance_8();
    this.k2f_1 = id;
    this.l2f_1 = img;
    this.m2f_1 = description;
    this.n2f_1 = permissions;
    this.o2f_1 = total;
    this.p2f_1 = referencesLink;
    this.q2f_1 = time;
  }
  protoOf(OrganizationTypeUpdatedEvent).k1y = function () {
    return this.k2f_1;
  };
  protoOf(OrganizationTypeUpdatedEvent).d2d = function () {
    return this.l2f_1;
  };
  protoOf(OrganizationTypeUpdatedEvent).w25 = function () {
    return this.m2f_1;
  };
  protoOf(OrganizationTypeUpdatedEvent).e2d = function () {
    return this.n2f_1;
  };
  protoOf(OrganizationTypeUpdatedEvent).i1z = function () {
    return this.o2f_1;
  };
  protoOf(OrganizationTypeUpdatedEvent).f2d = function () {
    return this.p2f_1;
  };
  protoOf(OrganizationTypeUpdatedEvent).g2c = function () {
    return this.q2f_1;
  };
  protoOf(OrganizationTypeUpdatedEvent).s2Id = function () {
    return this.k2f_1;
  };
  protoOf(OrganizationTypeUpdatedEvent).toString = function () {
    return 'OrganizationTypeUpdatedEvent(id=' + this.k2f_1 + ', img=' + this.l2f_1 + ', description=' + this.m2f_1 + ', permissions=' + this.n2f_1 + ', total=' + toString(this.o2f_1) + ', referencesLink=' + this.p2f_1 + ', time=' + toString(this.q2f_1) + ')';
  };
  protoOf(OrganizationTypeUpdatedEvent).hashCode = function () {
    var result = getStringHashCode(this.k2f_1);
    result = imul(result, 31) + (this.l2f_1 == null ? 0 : this.l2f_1.hashCode()) | 0;
    result = imul(result, 31) + (this.m2f_1 == null ? 0 : getStringHashCode(this.m2f_1)) | 0;
    result = imul(result, 31) + (this.n2f_1 == null ? 0 : hashCode(this.n2f_1)) | 0;
    result = imul(result, 31) + (this.o2f_1 == null ? 0 : this.o2f_1.hashCode()) | 0;
    result = imul(result, 31) + (this.p2f_1 == null ? 0 : getStringHashCode(this.p2f_1)) | 0;
    result = imul(result, 31) + (this.q2f_1 == null ? 0 : this.q2f_1.hashCode()) | 0;
    return result;
  };
  protoOf(OrganizationTypeUpdatedEvent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrganizationTypeUpdatedEvent))
      return false;
    var tmp0_other_with_cast = other instanceof OrganizationTypeUpdatedEvent ? other : THROW_CCE();
    if (!(this.k2f_1 === tmp0_other_with_cast.k2f_1))
      return false;
    if (!equals(this.l2f_1, tmp0_other_with_cast.l2f_1))
      return false;
    if (!(this.m2f_1 == tmp0_other_with_cast.m2f_1))
      return false;
    if (!equals(this.n2f_1, tmp0_other_with_cast.n2f_1))
      return false;
    if (!equals(this.o2f_1, tmp0_other_with_cast.o2f_1))
      return false;
    if (!(this.p2f_1 == tmp0_other_with_cast.p2f_1))
      return false;
    if (!equals(this.q2f_1, tmp0_other_with_cast.q2f_1))
      return false;
    return true;
  };
  function OrganizationDTO() {
  }
  function Companion_9() {
    Companion_instance_9 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.r2f_1 = [null, null, null, new ArrayListSerializer(StringSerializer_getInstance())];
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function $serializer_8() {
    $serializer_instance_8 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.organizationType.domain.model.Organization', this, 4);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('address', false);
    tmp0_serialDesc.ht('type', false);
    this.s2f_1 = tmp0_serialDesc;
  }
  protoOf($serializer_8).ii = function () {
    return this.s2f_1;
  };
  protoOf($serializer_8).wt = function () {
    var tmp0_cached = Companion_getInstance_9().r2f_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), StringSerializer_getInstance(), get_nullable($serializer_getInstance_0()), tmp0_cached[3]];
  };
  protoOf($serializer_8).ki = function (decoder) {
    var tmp0_desc = this.s2f_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_input = decoder.ul(tmp0_desc);
    var tmp9_cached = Companion_getInstance_9().r2f_1;
    if (tmp8_input.km()) {
      tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp8_input.gm(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp8_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp8_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp8_input.em(tmp0_desc, 1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp8_input.im(tmp0_desc, 2, $serializer_getInstance_0(), tmp6_local2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp8_input.gm(tmp0_desc, 3, tmp9_cached[3], tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp8_input.vl(tmp0_desc);
    return Organization_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
  };
  protoOf($serializer_8).t2f = function (encoder, value) {
    var tmp0_desc = this.s2f_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_9().r2f_1;
    tmp1_output.jn(tmp0_desc, 0, value.u2f_1);
    tmp1_output.jn(tmp0_desc, 1, value.v2f_1);
    tmp1_output.nn(tmp0_desc, 2, $serializer_getInstance_0(), value.w2f_1);
    tmp1_output.ln(tmp0_desc, 3, tmp2_cached[3], value.x2f_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_8).ji = function (encoder, value) {
    return this.t2f(encoder, value instanceof Organization ? value : THROW_CCE());
  };
  var $serializer_instance_8;
  function $serializer_getInstance_10() {
    if ($serializer_instance_8 == null)
      new $serializer_8();
    return $serializer_instance_8;
  }
  function Organization_init_$Init$(seen1, id, name, address, type, serializationConstructorMarker, $this) {
    if (!(15 === (15 & seen1))) {
      throwMissingFieldException(seen1, 15, $serializer_getInstance_10().s2f_1);
    }
    $this.u2f_1 = id;
    $this.v2f_1 = name;
    $this.w2f_1 = address;
    $this.x2f_1 = type;
    return $this;
  }
  function Organization_init_$Create$(seen1, id, name, address, type, serializationConstructorMarker) {
    return Organization_init_$Init$(seen1, id, name, address, type, serializationConstructorMarker, objectCreate(protoOf(Organization)));
  }
  function Organization() {
  }
  protoOf(Organization).k1y = function () {
    return this.u2f_1;
  };
  protoOf(Organization).h9 = function () {
    return this.v2f_1;
  };
  protoOf(Organization).x29 = function () {
    return this.w2f_1;
  };
  protoOf(Organization).j21 = function () {
    return this.x2f_1;
  };
  protoOf(Organization).toString = function () {
    return 'Organization(id=' + this.u2f_1 + ', name=' + this.v2f_1 + ', address=' + this.w2f_1 + ', type=' + this.x2f_1 + ')';
  };
  protoOf(Organization).hashCode = function () {
    var result = getStringHashCode(this.u2f_1);
    result = imul(result, 31) + getStringHashCode(this.v2f_1) | 0;
    result = imul(result, 31) + (this.w2f_1 == null ? 0 : this.w2f_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.x2f_1) | 0;
    return result;
  };
  protoOf(Organization).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Organization))
      return false;
    var tmp0_other_with_cast = other instanceof Organization ? other : THROW_CCE();
    if (!(this.u2f_1 === tmp0_other_with_cast.u2f_1))
      return false;
    if (!(this.v2f_1 === tmp0_other_with_cast.v2f_1))
      return false;
    if (!equals(this.w2f_1, tmp0_other_with_cast.w2f_1))
      return false;
    if (!equals(this.x2f_1, tmp0_other_with_cast.x2f_1))
      return false;
    return true;
  };
  function OrganizationTypeModelDTO() {
  }
  function Companion_10() {
    Companion_instance_10 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z2f_1 = [null, Companion_getInstance().x14(), null, null, null, new ArrayListSerializer(StringSerializer_getInstance()), null, null, null, null];
  }
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function $serializer_9() {
    $serializer_instance_9 = this;
    var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('org.boislocal.platform.s2.organizationType.domain.model.OrganizationTypeModel', this, 10);
    tmp0_serialDesc.ht('id', false);
    tmp0_serialDesc.ht('status', false);
    tmp0_serialDesc.ht('name', false);
    tmp0_serialDesc.ht('img', true);
    tmp0_serialDesc.ht('description', true);
    tmp0_serialDesc.ht('permissions', true);
    tmp0_serialDesc.ht('total', true);
    tmp0_serialDesc.ht('referencesLink', true);
    tmp0_serialDesc.ht('creationDate', false);
    tmp0_serialDesc.ht('updatedDate', false);
    this.a2g_1 = tmp0_serialDesc;
  }
  protoOf($serializer_9).ii = function () {
    return this.a2g_1;
  };
  protoOf($serializer_9).wt = function () {
    var tmp0_cached = Companion_getInstance_10().z2f_1;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [StringSerializer_getInstance(), tmp0_cached[1], StringSerializer_getInstance(), get_nullable($serializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(tmp0_cached[5]), get_nullable(LongSerializer_getInstance()), get_nullable(StringSerializer_getInstance()), get_nullable(LongSerializer_getInstance()), get_nullable(LongSerializer_getInstance())];
  };
  protoOf($serializer_9).ki = function (decoder) {
    var tmp0_desc = this.a2g_1;
    var tmp1_flag = true;
    var tmp2_index = 0;
    var tmp3_bitMask0 = 0;
    var tmp4_local0 = null;
    var tmp5_local1 = null;
    var tmp6_local2 = null;
    var tmp7_local3 = null;
    var tmp8_local4 = null;
    var tmp9_local5 = null;
    var tmp10_local6 = null;
    var tmp11_local7 = null;
    var tmp12_local8 = null;
    var tmp13_local9 = null;
    var tmp14_input = decoder.ul(tmp0_desc);
    var tmp15_cached = Companion_getInstance_10().z2f_1;
    if (tmp14_input.km()) {
      tmp4_local0 = tmp14_input.em(tmp0_desc, 0);
      tmp3_bitMask0 = tmp3_bitMask0 | 1;
      tmp5_local1 = tmp14_input.gm(tmp0_desc, 1, tmp15_cached[1], tmp5_local1);
      tmp3_bitMask0 = tmp3_bitMask0 | 2;
      tmp6_local2 = tmp14_input.em(tmp0_desc, 2);
      tmp3_bitMask0 = tmp3_bitMask0 | 4;
      tmp7_local3 = tmp14_input.im(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
      tmp3_bitMask0 = tmp3_bitMask0 | 8;
      tmp8_local4 = tmp14_input.im(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
      tmp3_bitMask0 = tmp3_bitMask0 | 16;
      tmp9_local5 = tmp14_input.im(tmp0_desc, 5, tmp15_cached[5], tmp9_local5);
      tmp3_bitMask0 = tmp3_bitMask0 | 32;
      tmp10_local6 = tmp14_input.im(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
      tmp3_bitMask0 = tmp3_bitMask0 | 64;
      tmp11_local7 = tmp14_input.im(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
      tmp3_bitMask0 = tmp3_bitMask0 | 128;
      tmp12_local8 = tmp14_input.im(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
      tmp3_bitMask0 = tmp3_bitMask0 | 256;
      tmp13_local9 = tmp14_input.im(tmp0_desc, 9, LongSerializer_getInstance(), tmp13_local9);
      tmp3_bitMask0 = tmp3_bitMask0 | 512;
    } else
      while (tmp1_flag) {
        tmp2_index = tmp14_input.lm(tmp0_desc);
        switch (tmp2_index) {
          case -1:
            tmp1_flag = false;
            break;
          case 0:
            tmp4_local0 = tmp14_input.em(tmp0_desc, 0);
            tmp3_bitMask0 = tmp3_bitMask0 | 1;
            break;
          case 1:
            tmp5_local1 = tmp14_input.gm(tmp0_desc, 1, tmp15_cached[1], tmp5_local1);
            tmp3_bitMask0 = tmp3_bitMask0 | 2;
            break;
          case 2:
            tmp6_local2 = tmp14_input.em(tmp0_desc, 2);
            tmp3_bitMask0 = tmp3_bitMask0 | 4;
            break;
          case 3:
            tmp7_local3 = tmp14_input.im(tmp0_desc, 3, $serializer_getInstance(), tmp7_local3);
            tmp3_bitMask0 = tmp3_bitMask0 | 8;
            break;
          case 4:
            tmp8_local4 = tmp14_input.im(tmp0_desc, 4, StringSerializer_getInstance(), tmp8_local4);
            tmp3_bitMask0 = tmp3_bitMask0 | 16;
            break;
          case 5:
            tmp9_local5 = tmp14_input.im(tmp0_desc, 5, tmp15_cached[5], tmp9_local5);
            tmp3_bitMask0 = tmp3_bitMask0 | 32;
            break;
          case 6:
            tmp10_local6 = tmp14_input.im(tmp0_desc, 6, LongSerializer_getInstance(), tmp10_local6);
            tmp3_bitMask0 = tmp3_bitMask0 | 64;
            break;
          case 7:
            tmp11_local7 = tmp14_input.im(tmp0_desc, 7, StringSerializer_getInstance(), tmp11_local7);
            tmp3_bitMask0 = tmp3_bitMask0 | 128;
            break;
          case 8:
            tmp12_local8 = tmp14_input.im(tmp0_desc, 8, LongSerializer_getInstance(), tmp12_local8);
            tmp3_bitMask0 = tmp3_bitMask0 | 256;
            break;
          case 9:
            tmp13_local9 = tmp14_input.im(tmp0_desc, 9, LongSerializer_getInstance(), tmp13_local9);
            tmp3_bitMask0 = tmp3_bitMask0 | 512;
            break;
          default:
            throw UnknownFieldException_init_$Create$(tmp2_index);
        }
      }
    tmp14_input.vl(tmp0_desc);
    return OrganizationTypeModel_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
  };
  protoOf($serializer_9).b2g = function (encoder, value) {
    var tmp0_desc = this.a2g_1;
    var tmp1_output = encoder.ul(tmp0_desc);
    var tmp2_cached = Companion_getInstance_10().z2f_1;
    tmp1_output.jn(tmp0_desc, 0, value.o2e_1);
    tmp1_output.ln(tmp0_desc, 1, tmp2_cached[1], value.p2e_1);
    tmp1_output.jn(tmp0_desc, 2, value.q2e_1);
    if (tmp1_output.rn(tmp0_desc, 3) ? true : !(value.r2e_1 == null)) {
      tmp1_output.nn(tmp0_desc, 3, $serializer_getInstance(), value.r2e_1);
    }
    if (tmp1_output.rn(tmp0_desc, 4) ? true : !(value.s2e_1 == null)) {
      tmp1_output.nn(tmp0_desc, 4, StringSerializer_getInstance(), value.s2e_1);
    }
    if (tmp1_output.rn(tmp0_desc, 5) ? true : !(value.t2e_1 == null)) {
      tmp1_output.nn(tmp0_desc, 5, tmp2_cached[5], value.t2e_1);
    }
    if (tmp1_output.rn(tmp0_desc, 6) ? true : !(value.u2e_1 == null)) {
      tmp1_output.nn(tmp0_desc, 6, LongSerializer_getInstance(), value.u2e_1);
    }
    if (tmp1_output.rn(tmp0_desc, 7) ? true : !(value.v2e_1 == null)) {
      tmp1_output.nn(tmp0_desc, 7, StringSerializer_getInstance(), value.v2e_1);
    }
    tmp1_output.nn(tmp0_desc, 8, LongSerializer_getInstance(), value.w2e_1);
    tmp1_output.nn(tmp0_desc, 9, LongSerializer_getInstance(), value.x2e_1);
    tmp1_output.vl(tmp0_desc);
  };
  protoOf($serializer_9).ji = function (encoder, value) {
    return this.b2g(encoder, value instanceof OrganizationTypeModel ? value : THROW_CCE());
  };
  var $serializer_instance_9;
  function $serializer_getInstance_11() {
    if ($serializer_instance_9 == null)
      new $serializer_9();
    return $serializer_instance_9;
  }
  function OrganizationTypeModel_init_$Init$(seen1, id, status, name, img, description, permissions, total, referencesLink, creationDate, updatedDate, serializationConstructorMarker, $this) {
    if (!(775 === (775 & seen1))) {
      throwMissingFieldException(seen1, 775, $serializer_getInstance_11().a2g_1);
    }
    $this.o2e_1 = id;
    $this.p2e_1 = status;
    $this.q2e_1 = name;
    if (0 === (seen1 & 8))
      $this.r2e_1 = null;
    else
      $this.r2e_1 = img;
    if (0 === (seen1 & 16))
      $this.s2e_1 = null;
    else
      $this.s2e_1 = description;
    if (0 === (seen1 & 32))
      $this.t2e_1 = null;
    else
      $this.t2e_1 = permissions;
    if (0 === (seen1 & 64))
      $this.u2e_1 = null;
    else
      $this.u2e_1 = total;
    if (0 === (seen1 & 128))
      $this.v2e_1 = null;
    else
      $this.v2e_1 = referencesLink;
    $this.w2e_1 = creationDate;
    $this.x2e_1 = updatedDate;
    return $this;
  }
  function OrganizationTypeModel_init_$Create$(seen1, id, status, name, img, description, permissions, total, referencesLink, creationDate, updatedDate, serializationConstructorMarker) {
    return OrganizationTypeModel_init_$Init$(seen1, id, status, name, img, description, permissions, total, referencesLink, creationDate, updatedDate, serializationConstructorMarker, objectCreate(protoOf(OrganizationTypeModel)));
  }
  function OrganizationTypeModel() {
  }
  protoOf(OrganizationTypeModel).k1y = function () {
    return this.o2e_1;
  };
  protoOf(OrganizationTypeModel).y2f = function () {
    return this.p2e_1;
  };
  protoOf(OrganizationTypeModel).h9 = function () {
    return this.q2e_1;
  };
  protoOf(OrganizationTypeModel).d2d = function () {
    return this.r2e_1;
  };
  protoOf(OrganizationTypeModel).w25 = function () {
    return this.s2e_1;
  };
  protoOf(OrganizationTypeModel).e2d = function () {
    return this.t2e_1;
  };
  protoOf(OrganizationTypeModel).i1z = function () {
    return this.u2e_1;
  };
  protoOf(OrganizationTypeModel).f2d = function () {
    return this.v2e_1;
  };
  protoOf(OrganizationTypeModel).s2State = function () {
    return this.p2e_1;
  };
  protoOf(OrganizationTypeModel).s2Id = function () {
    return this.o2e_1;
  };
  protoOf(OrganizationTypeModel).toString = function () {
    return 'OrganizationTypeModel(id=' + this.o2e_1 + ', status=' + this.p2e_1 + ', name=' + this.q2e_1 + ', img=' + this.r2e_1 + ', description=' + this.s2e_1 + ', permissions=' + this.t2e_1 + ', total=' + toString(this.u2e_1) + ', referencesLink=' + this.v2e_1 + ', creationDate=' + toString(this.w2e_1) + ', updatedDate=' + toString(this.x2e_1) + ')';
  };
  protoOf(OrganizationTypeModel).hashCode = function () {
    var result = getStringHashCode(this.o2e_1);
    result = imul(result, 31) + this.p2e_1.hashCode() | 0;
    result = imul(result, 31) + getStringHashCode(this.q2e_1) | 0;
    result = imul(result, 31) + (this.r2e_1 == null ? 0 : this.r2e_1.hashCode()) | 0;
    result = imul(result, 31) + (this.s2e_1 == null ? 0 : getStringHashCode(this.s2e_1)) | 0;
    result = imul(result, 31) + (this.t2e_1 == null ? 0 : hashCode(this.t2e_1)) | 0;
    result = imul(result, 31) + (this.u2e_1 == null ? 0 : this.u2e_1.hashCode()) | 0;
    result = imul(result, 31) + (this.v2e_1 == null ? 0 : getStringHashCode(this.v2e_1)) | 0;
    result = imul(result, 31) + (this.w2e_1 == null ? 0 : this.w2e_1.hashCode()) | 0;
    result = imul(result, 31) + (this.x2e_1 == null ? 0 : this.x2e_1.hashCode()) | 0;
    return result;
  };
  protoOf(OrganizationTypeModel).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof OrganizationTypeModel))
      return false;
    var tmp0_other_with_cast = other instanceof OrganizationTypeModel ? other : THROW_CCE();
    if (!(this.o2e_1 === tmp0_other_with_cast.o2e_1))
      return false;
    if (!this.p2e_1.equals(tmp0_other_with_cast.p2e_1))
      return false;
    if (!(this.q2e_1 === tmp0_other_with_cast.q2e_1))
      return false;
    if (!equals(this.r2e_1, tmp0_other_with_cast.r2e_1))
      return false;
    if (!(this.s2e_1 == tmp0_other_with_cast.s2e_1))
      return false;
    if (!equals(this.t2e_1, tmp0_other_with_cast.t2e_1))
      return false;
    if (!equals(this.u2e_1, tmp0_other_with_cast.u2e_1))
      return false;
    if (!(this.v2e_1 == tmp0_other_with_cast.v2e_1))
      return false;
    if (!equals(this.w2e_1, tmp0_other_with_cast.w2e_1))
      return false;
    if (!equals(this.x2e_1, tmp0_other_with_cast.x2e_1))
      return false;
    return true;
  };
  function OrganizationTypePolicies() {
  }
  protoOf(OrganizationTypePolicies).canPage = function (authedUser) {
    return true;
  };
  protoOf(OrganizationTypePolicies).canGet = function (authedUser) {
    return true;
  };
  protoOf(OrganizationTypePolicies).canCreate = function (authedUser) {
    return hasRole(authedUser, 'Marque');
  };
  protoOf(OrganizationTypePolicies).canUpdate = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().z2c_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(OrganizationTypeUpdateCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.organizationType.domain.policy.OrganizationTypePolicies.canUpdate.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(OrganizationTypePolicies).canDelete = function (authedUser, target) {
    // Inline function 'org.boislocal.platform.s2.commons.domain.model.canExecuteTransitionAnd' call
    var this_0 = S2_getInstance().z2c_1;
    var tmp;
    if (isAvailableTransition(this_0, target, ensureNotNull(getKClass(OrganizationTypeDeleteCommand).z5()))) {
      // Inline function 'org.boislocal.platform.s2.organizationType.domain.policy.OrganizationTypePolicies.canDelete.<anonymous>' call
      tmp = hasRole(authedUser, 'Marque');
    } else {
      tmp = false;
    }
    return tmp;
  };
  var OrganizationTypePolicies_instance;
  function OrganizationTypePolicies_getInstance() {
    return OrganizationTypePolicies_instance;
  }
  function OrganizationTypeGetQueryDTO() {
  }
  function OrganizationTypeGetResponseDTO() {
  }
  function OrganizationTypePageQueryDTO() {
  }
  function OrganizationTypePageResponseDTO() {
  }
  //region block: post-declaration
  defineProp(protoOf(OrganizationTypeState), 'position', function () {
    return this.jr();
  }, function (value) {
    this.y2c(value);
  });
  defineProp(protoOf(OrganizationTypeState), 'name', protoOf(OrganizationTypeState).h9);
  defineProp(protoOf(OrganizationTypeState), 'ordinal', protoOf(OrganizationTypeState).i9);
  protoOf($serializer).xt = typeParametersSerializers;
  protoOf($serializer_0).xt = typeParametersSerializers;
  defineProp(protoOf(OrganizationTypeCreateCommand), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(OrganizationTypeCreateCommand), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(OrganizationTypeCreateCommand), 'description', function () {
    return this.w25();
  });
  defineProp(protoOf(OrganizationTypeCreateCommand), 'permissions', function () {
    return this.e2d();
  });
  defineProp(protoOf(OrganizationTypeCreateCommand), 'total', function () {
    return this.i1z();
  });
  defineProp(protoOf(OrganizationTypeCreateCommand), 'referencesLink', function () {
    return this.f2d();
  });
  protoOf($serializer_1).xt = typeParametersSerializers;
  defineProp(protoOf(OrganizationTypeCreatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OrganizationTypeCreatedEvent), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(OrganizationTypeCreatedEvent), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(OrganizationTypeCreatedEvent), 'description', function () {
    return this.w25();
  });
  defineProp(protoOf(OrganizationTypeCreatedEvent), 'permissions', function () {
    return this.e2d();
  });
  defineProp(protoOf(OrganizationTypeCreatedEvent), 'total', function () {
    return this.i1z();
  });
  defineProp(protoOf(OrganizationTypeCreatedEvent), 'referencesLink', function () {
    return this.f2d();
  });
  defineProp(protoOf(OrganizationTypeCreatedEvent), 'time');
  protoOf($serializer_2).xt = typeParametersSerializers;
  defineProp(protoOf(OrganizationTypeDeleteCommand), 'id', function () {
    return this.k1y();
  });
  protoOf($serializer_3).xt = typeParametersSerializers;
  defineProp(protoOf(OrganizationTypeDeletedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OrganizationTypeDeletedEvent), 'time');
  protoOf($serializer_4).xt = typeParametersSerializers;
  defineProp(protoOf(OrganizationTypeImportCommand), 'item', function () {
    return this.q20();
  });
  protoOf($serializer_5).xt = typeParametersSerializers;
  defineProp(protoOf(OrganizationTypeImportedEvent), 'item', function () {
    return this.q20();
  });
  defineProp(protoOf(OrganizationTypeImportedEvent), 'time');
  protoOf($serializer_6).xt = typeParametersSerializers;
  defineProp(protoOf(OrganizationTypeUpdateCommand), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OrganizationTypeUpdateCommand), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(OrganizationTypeUpdateCommand), 'description', function () {
    return this.w25();
  });
  defineProp(protoOf(OrganizationTypeUpdateCommand), 'permissions', function () {
    return this.e2d();
  });
  defineProp(protoOf(OrganizationTypeUpdateCommand), 'total', function () {
    return this.i1z();
  });
  defineProp(protoOf(OrganizationTypeUpdateCommand), 'referencesLink', function () {
    return this.f2d();
  });
  protoOf($serializer_7).xt = typeParametersSerializers;
  defineProp(protoOf(OrganizationTypeUpdatedEvent), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OrganizationTypeUpdatedEvent), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(OrganizationTypeUpdatedEvent), 'description', function () {
    return this.w25();
  });
  defineProp(protoOf(OrganizationTypeUpdatedEvent), 'permissions', function () {
    return this.e2d();
  });
  defineProp(protoOf(OrganizationTypeUpdatedEvent), 'total', function () {
    return this.i1z();
  });
  defineProp(protoOf(OrganizationTypeUpdatedEvent), 'referencesLink', function () {
    return this.f2d();
  });
  defineProp(protoOf(OrganizationTypeUpdatedEvent), 'time');
  protoOf($serializer_8).xt = typeParametersSerializers;
  defineProp(protoOf(Organization), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(Organization), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(Organization), 'address', function () {
    return this.x29();
  });
  defineProp(protoOf(Organization), 'type', function () {
    return this.j21();
  });
  protoOf($serializer_9).xt = typeParametersSerializers;
  defineProp(protoOf(OrganizationTypeModel), 'id', function () {
    return this.k1y();
  });
  defineProp(protoOf(OrganizationTypeModel), 'status', function () {
    return this.y2f();
  });
  defineProp(protoOf(OrganizationTypeModel), 'name', function () {
    return this.h9();
  });
  defineProp(protoOf(OrganizationTypeModel), 'img', function () {
    return this.d2d();
  });
  defineProp(protoOf(OrganizationTypeModel), 'description', function () {
    return this.w25();
  });
  defineProp(protoOf(OrganizationTypeModel), 'permissions', function () {
    return this.e2d();
  });
  defineProp(protoOf(OrganizationTypeModel), 'total', function () {
    return this.i1z();
  });
  defineProp(protoOf(OrganizationTypeModel), 'referencesLink', function () {
    return this.f2d();
  });
  //endregion
  //region block: init
  Companion_instance_0 = new Companion_0();
  Companion_instance_3 = new Companion_3();
  Companion_instance_4 = new Companion_4();
  Companion_instance_5 = new Companion_5();
  Companion_instance_6 = new Companion_6();
  OrganizationTypePolicies_instance = new OrganizationTypePolicies();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$organizationType = $org$boislocal$platform$s2.organizationType || ($org$boislocal$platform$s2.organizationType = {});
    var $org$boislocal$platform$s2$organizationType$domain = $org$boislocal$platform$s2$organizationType.domain || ($org$boislocal$platform$s2$organizationType.domain = {});
    var $org$boislocal$platform$s2$organizationType$domain$automate = $org$boislocal$platform$s2$organizationType$domain.automate || ($org$boislocal$platform$s2$organizationType$domain.automate = {});
    $org$boislocal$platform$s2$organizationType$domain$automate.OrganizationTypeState = OrganizationTypeState;
    $org$boislocal$platform$s2$organizationType$domain$automate.OrganizationTypeState.values = values;
    $org$boislocal$platform$s2$organizationType$domain$automate.OrganizationTypeState.valueOf = valueOf;
    defineProp($org$boislocal$platform$s2$organizationType$domain$automate.OrganizationTypeState, 'Exists', OrganizationTypeState_Exists_getInstance);
    defineProp($org$boislocal$platform$s2$organizationType$domain$automate.OrganizationTypeState, 'Deleted', OrganizationTypeState_Deleted_getInstance);
    defineProp($org$boislocal$platform$s2$organizationType$domain$automate.OrganizationTypeState, 'Companion', Companion_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$organizationType = $org$boislocal$platform$s2.organizationType || ($org$boislocal$platform$s2.organizationType = {});
    var $org$boislocal$platform$s2$organizationType$domain = $org$boislocal$platform$s2$organizationType.domain || ($org$boislocal$platform$s2$organizationType.domain = {});
    var $org$boislocal$platform$s2$organizationType$domain$command = $org$boislocal$platform$s2$organizationType$domain.command || ($org$boislocal$platform$s2$organizationType$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$organizationType = $org$boislocal$platform$s2.organizationType || ($org$boislocal$platform$s2.organizationType = {});
    var $org$boislocal$platform$s2$organizationType$domain = $org$boislocal$platform$s2$organizationType.domain || ($org$boislocal$platform$s2$organizationType.domain = {});
    var $org$boislocal$platform$s2$organizationType$domain$command = $org$boislocal$platform$s2$organizationType$domain.command || ($org$boislocal$platform$s2$organizationType$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$organizationType = $org$boislocal$platform$s2.organizationType || ($org$boislocal$platform$s2.organizationType = {});
    var $org$boislocal$platform$s2$organizationType$domain = $org$boislocal$platform$s2$organizationType.domain || ($org$boislocal$platform$s2$organizationType.domain = {});
    var $org$boislocal$platform$s2$organizationType$domain$command = $org$boislocal$platform$s2$organizationType$domain.command || ($org$boislocal$platform$s2$organizationType$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$organizationType = $org$boislocal$platform$s2.organizationType || ($org$boislocal$platform$s2.organizationType = {});
    var $org$boislocal$platform$s2$organizationType$domain = $org$boislocal$platform$s2$organizationType.domain || ($org$boislocal$platform$s2$organizationType.domain = {});
    var $org$boislocal$platform$s2$organizationType$domain$command = $org$boislocal$platform$s2$organizationType$domain.command || ($org$boislocal$platform$s2$organizationType$domain.command = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$organizationType = $org$boislocal$platform$s2.organizationType || ($org$boislocal$platform$s2.organizationType = {});
    var $org$boislocal$platform$s2$organizationType$domain = $org$boislocal$platform$s2$organizationType.domain || ($org$boislocal$platform$s2$organizationType.domain = {});
    var $org$boislocal$platform$s2$organizationType$domain$model = $org$boislocal$platform$s2$organizationType$domain.model || ($org$boislocal$platform$s2$organizationType$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$organizationType = $org$boislocal$platform$s2.organizationType || ($org$boislocal$platform$s2.organizationType = {});
    var $org$boislocal$platform$s2$organizationType$domain = $org$boislocal$platform$s2$organizationType.domain || ($org$boislocal$platform$s2$organizationType.domain = {});
    var $org$boislocal$platform$s2$organizationType$domain$model = $org$boislocal$platform$s2$organizationType$domain.model || ($org$boislocal$platform$s2$organizationType$domain.model = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$organizationType = $org$boislocal$platform$s2.organizationType || ($org$boislocal$platform$s2.organizationType = {});
    var $org$boislocal$platform$s2$organizationType$domain = $org$boislocal$platform$s2$organizationType.domain || ($org$boislocal$platform$s2$organizationType.domain = {});
    var $org$boislocal$platform$s2$organizationType$domain$policy = $org$boislocal$platform$s2$organizationType$domain.policy || ($org$boislocal$platform$s2$organizationType$domain.policy = {});
    defineProp($org$boislocal$platform$s2$organizationType$domain$policy, 'OrganizationTypePolicies', OrganizationTypePolicies_getInstance);
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$organizationType = $org$boislocal$platform$s2.organizationType || ($org$boislocal$platform$s2.organizationType = {});
    var $org$boislocal$platform$s2$organizationType$domain = $org$boislocal$platform$s2$organizationType.domain || ($org$boislocal$platform$s2$organizationType.domain = {});
    var $org$boislocal$platform$s2$organizationType$domain$query = $org$boislocal$platform$s2$organizationType$domain.query || ($org$boislocal$platform$s2$organizationType$domain.query = {});
    var $org = _.org || (_.org = {});
    var $org$boislocal = $org.boislocal || ($org.boislocal = {});
    var $org$boislocal$platform = $org$boislocal.platform || ($org$boislocal.platform = {});
    var $org$boislocal$platform$s2 = $org$boislocal$platform.s2 || ($org$boislocal$platform.s2 = {});
    var $org$boislocal$platform$s2$organizationType = $org$boislocal$platform$s2.organizationType || ($org$boislocal$platform$s2.organizationType = {});
    var $org$boislocal$platform$s2$organizationType$domain = $org$boislocal$platform$s2$organizationType.domain || ($org$boislocal$platform$s2$organizationType.domain = {});
    var $org$boislocal$platform$s2$organizationType$domain$query = $org$boislocal$platform$s2$organizationType$domain.query || ($org$boislocal$platform$s2$organizationType$domain.query = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = $serializer_getInstance_10;
  _.$_$.b = $serializer_getInstance_11;
  //endregion
  return _;
}));

//# sourceMappingURL=boislocal-platform-platform-s2-referential-organizationType-organizationType-domain.js.map
